module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  locals.attributes = Util.object(locals.attributes) 
    ; __append("\n\n")
    ;  var name = Html.generateName() 
    ; __append("\n\n")
    ;  locals.attributes["name"] = name 
    ; __append("\n\n")
    ;  var attr = Html.attributes(locals.attributes) 
    ; __append("\n\n")
    ;  if (locals.prepend) { 
    ; __append("\n")
    ;  Util.each(locals.prepend, function (item) { 
    ; __append("\n<label>\n	<input\n		")
    ; __append( attr )
    ; __append("\n		type=\"radio\"\n		value=\"")
    ; __append(escapeFn( item.value ))
    ; __append("\"\n		")
    ; __append( Html.checked(locals.checked === item.value) )
    ; __append("\n		>\n	<span>\n		")
    ; __append(escapeFn( item.title ))
    ; __append("\n	</span>\n</label>\n")
    ;  }) 
    ; __append("\n")
    ;  } 
    ; __append("\n\n")
    ;  locals.enum.each(function (value) { 
    ; __append("\n<label>\n	<input\n		")
    ; __append(escapeFn( attr ))
    ; __append("\n		type=\"radio\"\n		value=\"")
    ; __append(escapeFn( value ))
    ; __append("\"\n		")
    ; __append( Html.checked(locals.checked === value) )
    ; __append("\n		>\n	<span>\n		")
    ; __append(escapeFn( locals.enum.title(value) ))
    ; __append("\n	</span>\n</label>\n")
    ;  }) 
    ; __append("\n\n")
    ;  if (locals.append) { 
    ; __append("\n")
    ;  Util.each(locals.append, function (item) { 
    ; __append("\n<label>\n	<input\n		")
    ; __append(escapeFn( attr ))
    ; __append("\n		type=\"radio\"\n		value=\"")
    ; __append(escapeFn( item.value ))
    ; __append("\"\n		")
    ; __append( Html.checked(locals.checked === item.value) )
    ; __append("\n		>\n	<span>\n		")
    ; __append(escapeFn( item.title ))
    ; __append("\n	</span>\n</label>\n")
    ;  }) 
    ; __append("\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}